import { ZonedDateTime, now, getLocalTimeZone } from '@internationalized/date';
import { useState } from 'react';
import { truncateToMinutes } from '@/utils/helpers';

const getNowTimezoned = () => {
  const timeZone = getLocalTimeZone();
  return truncateToMinutes(now(timeZone));
};

export const useGoTimeState = (orCaseDateTime: ZonedDateTime | null) => {
  const [goDateTime, setGoDateTime] = useState<ZonedDateTime>(getNowTimezoned());
  const applyGoTime = !!orCaseDateTime && orCaseDateTime.toDate() < new Date();

  return {
    goDateTime,
    setGoDateTime,
    applyGoTime,
  };
};
